<template>
	<vx-card :title='$t("Projects")'>

		<div class="flex flex-wrap justify-between items-center">

			<!-- ITEMS PER PAGE -->
			<div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">

				<vs-dropdown v-if="this.gridApi" vs-trigger-click class="cursor-pointer">
					<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
						<span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ gridApi.getDisplayedRowCount() - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : gridApi.getDisplayedRowCount() }} of {{ gridApi.getDisplayedRowCount() }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>

					<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
					<vs-dropdown-menu>

						<vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
							<span>100</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
							<span>150</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>

				<div style="float:right;" v-if="tableData">
					<vs-button v-if="$checkPermission(201)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" class="ml-6 mt-1" @click="addProjectPrompt = true">{{$t("Add")}}</vs-button>
				</div>

			</div>


			<!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
			<div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
				<vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
				<!--<vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>-->
				<vs-select autocomplete multiple class="selectExample" v-model="selectedColumns">
					<vs-select-item :key="index" :value="item.Field" :text="item.Name" v-for="(item,index) in totalColumnList" />
				</vs-select>
				<vs-button class="ml-3" type="border" color="success" @click="resizeColumns" icon-pack="feather" icon="icon-maximize-2"/>
			</div>
		</div>

		<ag-grid-vue
				ref="agGridTable"
				:gridOptions="gridOptions"
				class="ag-theme-material w-100 my-4 ag-grid-table"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="tableData"
				rowSelection="multiple"
				colResizeDefault="shift"
				domLayout="autoHeight"
				:animateRows="true"
				:floatingFilter="true"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true">
		</ag-grid-vue>
		<vs-pagination
				:total="totalPages"
				:max="maxPageNumbers"
				v-model="currentPage" />

		<vs-popup :title="$t('Add')" :active.sync="addProjectPrompt">
			<div>

				<p class="mt-6">{{$t("Name")}}</p>
				<vs-input v-model="projectAdding['name']" style="width: 100%"/>
				<p class="mt-6">{{$t("Client")}}</p>
				<vs-select autocomplete style="width: 100%" class="selectExample" v-model="projectAddingClient">
					<vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyClients" />
				</vs-select>
				<p class="mt-6">{{$t("AssignedUser")}}</p>
				<vs-select autocomplete style="width: 100%" class="selectExample" v-model="projectAdding['company_user_id']">
					<vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyUsers" />
				</vs-select>
				<p class="mt-6">{{$t("Description")}}</p>
				<vs-textarea v-model="projectAdding['description']" class="w-full" />
				<vs-divider/>
				<vs-button color="success" type="border" class="mt-6; mr-1" @click="addProject">{{$t("Add")}}</vs-button>
			</div>
		</vs-popup>

	</vx-card>
</template>
<script>

	import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
	import ProjectsTableTimeWorkedRenderer from "./ProjectsTableTimeWorkedRenderer";
	import { AgGridVue } from "ag-grid-vue"

	export default {
		components: {
			AgGridVue,
			ProjectsTableTimeWorkedRenderer
		},
		props: {
			listType: {
				type: String,
				required: true
			},
		},
		data() {
			return {

				selected: {},
				projects: [],

				itemsPerPage: 20,
				isMounted: false,

				addProjectPrompt: false,

				projectAdding: {},
				projectAddingClient: '',

				searchQuery: '',
				gridOptions: {
					suppressRowClickSelection: true,
					onCellClicked: (e) => {
						this.$router.push({ name: 'project', params: { id: "" + e.data.id } })
					},
					onRowDataChanged: () => {
						this.$nextTick(() => {
							this.gridColumnApi.autoSizeColumns(['client', 'name', 'completed_percent', 'time_planned', 'time_worked', 'user']);
							if(this.columnsWidth < this.tableWidth){
								this.gridApi.sizeColumnsToFit()
							}
						});
					}
				},
				maxPageNumbers: 10,
				gridApi: null,
				gridColumnApi: null,
				defaultColDef: {
					sortable: true,
					editable: false,
					resizable: true,
					suppressMenu: true
				},
				columnDefs: [
					{
						headerName: this.$t("Client"),
						field: 'client',
						filter: true,
					},
					{
						headerName: this.$t("Name"),
						field: 'name',
						filter: true,
					},
					{
						headerName: this.$t("Finished"),
						field: 'completed_percent',
						filter: true,
						valueGetter: this.finishedValueGetter,
					},
					{
						headerName: this.$t("PlannedTime"),
						field: 'time_planned',
						filter: true,
						valueGetter: this.timeValueGetter,
					},
					{
						headerName: this.$t("TimeWorked"),
						field: 'time_worked',
						filter: true,
						cellRendererFramework: ProjectsTableTimeWorkedRenderer,
					},
					{
						headerName: this.$t("ProjectLeader"),
						field: 'user',
						filter: true,
					},
				],

				totalColumnList: [],
			}
		},
		computed: {
			tableData() {
				let data = [];
				for(let x = 0; x < this.projects.length; x++){
					data.push({
						id: this.projects[x].id,
						client: this.$store.getters.companyClients[ this.projects[x].client_company_id].name,
						name: this.projects[x].name,
						user: this.$store.getters.companyUsers[this.projects[x].company_user_id].name,
						completed_percent: this.projects[x].completed_percent,
						time_planned: this.projects[x].time_planned,
						time_worked: this.projects[x].time_worked
					})
				}

				return data;
			},
			columnsWidth() {
				let total = 0;
				let state = this.gridColumnApi.getColumnState();
				for(let x = 0; x < state.length; x++){
					total += state[x].width
				}
				return total;
			},
			tableWidth() {
				return this.gridApi.gridPanel.eBodyViewport.clientWidth;
			},
			paginationPageSize() {
				if(this.gridApi) return this.gridApi.paginationGetPageSize()
				else return 50
			},
			totalPages() {
				if(this.gridApi) return this.gridApi.paginationGetTotalPages()
				else return 0
			},
			currentPage: {
				get() {
					if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
					else return 1
				},
				set(val) {
					this.gridApi.paginationGoToPage(val - 1)
				}
			},
			selectedColumns: {
				get() {
					let list = [];
					for(let x = 0; x < this.totalColumnList.length; x++){
						if(!this.$store.state.hiddenProjectsColumns.includes(this.totalColumnList[x].Field)){
							list.push(this.totalColumnList[x].Field)
						}
					}

					return list;
				},
				set(val) {

					let list = [];
					for(let x = 0; x < this.totalColumnList.length; x++){
						if(!val.includes(this.totalColumnList[x].Field)){
							list.push(this.totalColumnList[x].Field)
						}
					}

					this.$store.commit('SET_HIDDEN_PROJECTS_COLUMNS', list);
				}
			}
		},
		methods: {
			resizeColumns(){
				this.gridColumnApi.autoSizeColumns(['client', 'name', 'completed_percent', 'time_planned', 'time_worked', 'user']);
				if(this.columnsWidth < this.tableWidth){
					this.gridApi.sizeColumnsToFit()
				}
			},
			updateSearchQuery(val) {
				this.gridApi.setQuickFilter(val)
			},
			handleSelected(tr) {
				this.$router.push({ name: 'project', params: { id: tr.id } })
			},
			updateProjects() {
				const thisIns = this;
				this.$http.get('/api/v1/project?type=' + this.listType)
						.then(function (response) {
							thisIns.projects = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			addProject() {
				const thisIns = this;

				thisIns.projectAdding['client_company_id'] = thisIns.projectAddingClient;

				this.$http.post('/api/v1/project/', this.projectAdding)
						.then(function () {
							thisIns.addProjectPrompt = false;
							thisIns.updateProjects();
							thisIns.projectAdding = {}
						}).catch(function (error) {
					thisIns.addProjectPrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});


			},
			timeValueGetter(param) {
				return param.data.time_planned + "h"
			},
			finishedValueGetter(param) {
				return param.data.completed_percent + "%"
			}
		},
		watch: {
			editProjectPrompt: function () {
				if(!this.editProjectPrompt){
					this.selected = {}
				}
			},
			listType: function () {
				this.updateProjects();
			},
			'$store.state.hiddenProjectsColumns'(val) {
				for(let x = 0; x < this.totalColumnList.length; x++){
					if(val.includes(this.totalColumnList[x].Field)){
						this.gridOptions.columnApi.setColumnVisible(this.totalColumnList[x].Field, false)
					}else{
						this.gridOptions.columnApi.setColumnVisible(this.totalColumnList[x].Field, true)
					}
				}

				this.resizeColumns();
			},
		},
		created() {
			this.updateProjects()
		},
		mounted() {
			this.gridApi = this.gridOptions.api;
			this.gridColumnApi = this.gridOptions.columnApi;
			this.isMounted = true;

			this.totalColumnList = [];
			for(let x = 0; x < this.gridColumnApi.columnController.columnDefs.length; x++){
				this.totalColumnList.push({Name: this.gridColumnApi.columnController.columnDefs[x].headerName, Field: this.gridColumnApi.columnController.columnDefs[x].field})
				if(this.$store.state.hiddenProjectsColumns.includes(this.gridColumnApi.columnController.columnDefs[x].field)){
					this.gridOptions.columnApi.setColumnVisible(this.gridColumnApi.columnController.columnDefs[x].field, false)
				}else{
					this.gridOptions.columnApi.setColumnVisible(this.gridColumnApi.columnController.columnDefs[x].field, true)
				}
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.addProjectPrompt){
				this.addProjectPrompt = false;
				next(false)
			}else{
				next()
			}
		}
	}
</script>
